import {css} from 'styled-components';
import breakpoints from '@/theme/constants/breakpoints';

const container = {
  maxWidth: '1170px',
  padding: '0 15px',
} as const;

/**
 * @description Styles for the Bootstrap container translated to styled-components.
 * while transiting from bootstrap styles, this is reused on pages
 * ONLY where the Bootstrap layout is still in use.
 */
export const bootstrapContainerStyles = css`
  margin: 0 auto;
  max-width: 100%;
  width: 100%;
  max-width: ${container.maxWidth};
  padding: ${container.padding};

  @media only screen and ${breakpoints.device.s} {
    max-width: 540px;
  }
  @media only screen and ${breakpoints.device.m} {
    max-width: 720px;
  }
  @media only screen and ${breakpoints.device.l} {
    max-width: 960px;
  }
  @media only screen and ${breakpoints.device.xl} {
    max-width: 1140px;
  }
`;

export default container;
